// Official-style Cloud Service Icons for AWS, Azure, and GCP
// These are simplified vector representations of cloud services

export const CloudIcons = {
  // AWS Icons
  aws: {
    // Networking & Content Delivery
    route53: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#8C4FFF"/>
        <path d="M32 16C23.164 16 16 23.164 16 32s7.164 16 16 16 16-7.164 16-16-7.164-16-16-16zm0 28c-6.627 0-12-5.373-12-12s5.373-12 12-12 12 5.373 12 12-5.373 12-12 12z" fill="white"/>
        <circle cx="32" cy="32" r="6" fill="white"/>
        <path d="M32 20v8M32 36v8M20 32h8M36 32h8" stroke="white" strokeWidth="2"/>
      </svg>
    ),
    cloudfront: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#8C4FFF"/>
        <path d="M32 16L18 24v16l14 8 14-8V24L32 16z" fill="white" fillOpacity="0.2" stroke="white" strokeWidth="2"/>
        <circle cx="32" cy="32" r="8" fill="white"/>
        <path d="M32 24v-4M40 28l3-3M44 36h4M40 40l3 3M32 44v4M24 40l-3 3M20 36h-4M24 28l-3-3" stroke="white" strokeWidth="1.5"/>
      </svg>
    ),
    elb: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#8C4FFF"/>
        <circle cx="32" cy="22" r="6" fill="white"/>
        <circle cx="22" cy="42" r="5" fill="white"/>
        <circle cx="32" cy="42" r="5" fill="white"/>
        <circle cx="42" cy="42" r="5" fill="white"/>
        <path d="M32 28L22 37M32 28v9M32 28l10 9" stroke="white" strokeWidth="2"/>
      </svg>
    ),
    vpc: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#8C4FFF"/>
        <rect x="14" y="14" width="36" height="36" rx="4" stroke="white" strokeWidth="2" strokeDasharray="4 2"/>
        <rect x="20" y="20" width="10" height="10" fill="white" fillOpacity="0.3"/>
        <rect x="34" y="20" width="10" height="10" fill="white" fillOpacity="0.3"/>
        <rect x="20" y="34" width="10" height="10" fill="white" fillOpacity="0.3"/>
        <rect x="34" y="34" width="10" height="10" fill="white" fillOpacity="0.3"/>
      </svg>
    ),
    waf: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#DD344C"/>
        <path d="M32 14L16 22v14c0 8 6.4 15.4 16 18 9.6-2.6 16-10 16-18V22L32 14z" fill="white" fillOpacity="0.2" stroke="white" strokeWidth="2"/>
        <path d="M28 32l4 4 8-8" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    // Compute
    ec2: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#ED7100"/>
        <rect x="18" y="18" width="28" height="28" rx="2" fill="white" fillOpacity="0.2" stroke="white" strokeWidth="2"/>
        <rect x="24" y="24" width="16" height="16" fill="white"/>
        <circle cx="32" cy="32" r="4" fill="#ED7100"/>
      </svg>
    ),
    ecs: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#ED7100"/>
        <rect x="16" y="22" width="14" height="10" rx="2" fill="white"/>
        <rect x="34" y="22" width="14" height="10" rx="2" fill="white"/>
        <rect x="16" y="36" width="14" height="10" rx="2" fill="white"/>
        <rect x="34" y="36" width="14" height="10" rx="2" fill="white"/>
        <path d="M30 27h4M30 41h4" stroke="white" strokeWidth="2"/>
      </svg>
    ),
    lambda: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#ED7100"/>
        <path d="M20 44L32 20l12 24" stroke="white" strokeWidth="3" fill="none"/>
        <path d="M24 36h16" stroke="white" strokeWidth="2"/>
      </svg>
    ),
    fargate: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#ED7100"/>
        <rect x="20" y="18" width="24" height="28" rx="3" fill="white" fillOpacity="0.2" stroke="white" strokeWidth="2"/>
        <path d="M26 26h12M26 32h12M26 38h8" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
    // Database
    rds: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#3B48CC"/>
        <ellipse cx="32" cy="22" rx="14" ry="6" fill="white"/>
        <path d="M18 22v20c0 3.3 6.3 6 14 6s14-2.7 14-6V22" stroke="white" strokeWidth="2"/>
        <ellipse cx="32" cy="32" rx="14" ry="6" fill="white" fillOpacity="0.3"/>
        <ellipse cx="32" cy="42" rx="14" ry="6" fill="white" fillOpacity="0.3"/>
      </svg>
    ),
    aurora: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#3B48CC"/>
        <ellipse cx="32" cy="20" rx="12" ry="5" fill="white"/>
        <path d="M20 20v24c0 2.8 5.4 5 12 5s12-2.2 12-5V20" stroke="white" strokeWidth="2"/>
        <path d="M32 30l-8 8h16l-8-8z" fill="white"/>
      </svg>
    ),
    dynamodb: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#3B48CC"/>
        <path d="M32 16L18 24v16l14 8 14-8V24L32 16z" fill="white" fillOpacity="0.2" stroke="white" strokeWidth="2"/>
        <ellipse cx="32" cy="32" rx="8" ry="4" fill="white"/>
      </svg>
    ),
    elasticache: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#3B48CC"/>
        <rect x="18" y="24" width="28" height="16" rx="2" fill="white"/>
        <path d="M24 32h4M30 32h4M36 32h4" stroke="#3B48CC" strokeWidth="2" strokeLinecap="round"/>
        <path d="M22 20l4 4M42 20l-4 4M22 44l4-4M42 44l-4-4" stroke="white" strokeWidth="2"/>
      </svg>
    ),
    // Storage
    s3: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#569A31"/>
        <path d="M32 16L16 24v16l16 8 16-8V24L32 16z" fill="white" fillOpacity="0.2" stroke="white" strokeWidth="2"/>
        <ellipse cx="32" cy="32" rx="8" ry="4" fill="white"/>
        <path d="M24 32v8l8 4 8-4v-8" stroke="white" strokeWidth="1.5"/>
      </svg>
    ),
    // Security
    iam: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#DD344C"/>
        <circle cx="32" cy="24" r="8" fill="white"/>
        <path d="M20 48c0-6.6 5.4-12 12-12s12 5.4 12 12" stroke="white" strokeWidth="3" strokeLinecap="round"/>
      </svg>
    ),
    kms: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#DD344C"/>
        <circle cx="28" cy="32" r="10" fill="white" fillOpacity="0.3" stroke="white" strokeWidth="2"/>
        <path d="M36 32h12M44 28v8" stroke="white" strokeWidth="3" strokeLinecap="round"/>
      </svg>
    ),
    secretsmanager: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#DD344C"/>
        <rect x="22" y="28" width="20" height="16" rx="2" fill="white"/>
        <path d="M32 20a6 6 0 00-6 6v2h12v-2a6 6 0 00-6-6z" stroke="white" strokeWidth="2"/>
        <circle cx="32" cy="36" r="2" fill="#DD344C"/>
      </svg>
    ),
    // Management
    cloudwatch: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#E7157B"/>
        <circle cx="32" cy="32" r="14" fill="white" fillOpacity="0.2" stroke="white" strokeWidth="2"/>
        <path d="M32 22v10l6 6" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
      </svg>
    ),
    // DevOps
    codecommit: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#3B48CC"/>
        <circle cx="32" cy="24" r="6" fill="white"/>
        <circle cx="24" cy="42" r="4" fill="white"/>
        <circle cx="40" cy="42" r="4" fill="white"/>
        <path d="M32 30v6M28 36l-4 6M36 36l4 6" stroke="white" strokeWidth="2"/>
      </svg>
    ),
    codepipeline: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#3B48CC"/>
        <rect x="14" y="26" width="10" height="12" rx="2" fill="white"/>
        <rect x="27" y="26" width="10" height="12" rx="2" fill="white"/>
        <rect x="40" y="26" width="10" height="12" rx="2" fill="white"/>
        <path d="M24 32h3M37 32h3" stroke="white" strokeWidth="2"/>
      </svg>
    ),
    codebuild: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#3B48CC"/>
        <rect x="18" y="18" width="28" height="28" rx="3" fill="white" fillOpacity="0.2" stroke="white" strokeWidth="2"/>
        <path d="M26 28l6 4-6 4M34 32h6" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
    codedeploy: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#3B48CC"/>
        <path d="M32 18v20M32 38l-8-8M32 38l8-8" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        <rect x="18" y="42" width="28" height="6" rx="1" fill="white"/>
      </svg>
    ),
    ecr: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#ED7100"/>
        <rect x="18" y="22" width="28" height="20" rx="2" fill="white" fillOpacity="0.2" stroke="white" strokeWidth="2"/>
        <rect x="24" y="28" width="6" height="8" fill="white"/>
        <rect x="34" y="28" width="6" height="8" fill="white"/>
      </svg>
    ),
    // API & Integration
    apigateway: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#E7157B"/>
        <path d="M18 32h8l4-8 4 16 4-16 4 8h8" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="18" cy="32" r="3" fill="white"/>
        <circle cx="46" cy="32" r="3" fill="white"/>
      </svg>
    ),
    sns: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#E7157B"/>
        <circle cx="32" cy="24" r="8" fill="white"/>
        <path d="M20 44l6-10M44 44l-6-10M32 32v12" stroke="white" strokeWidth="2.5"/>
        <circle cx="20" cy="44" r="4" fill="white"/>
        <circle cx="44" cy="44" r="4" fill="white"/>
        <circle cx="32" cy="44" r="4" fill="white"/>
      </svg>
    ),
    sqs: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#E7157B"/>
        <rect x="18" y="24" width="28" height="16" rx="2" fill="white" fillOpacity="0.3" stroke="white" strokeWidth="2"/>
        <path d="M22 30h8M22 34h12" stroke="white" strokeWidth="2" strokeLinecap="round"/>
        <path d="M38 32l6-4v8l-6-4z" fill="white"/>
      </svg>
    ),
  },
  
  // Azure Icons
  azure: {
    frontdoor: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#0078D4"/>
        <path d="M18 32h28M32 18v28" stroke="white" strokeWidth="2"/>
        <circle cx="32" cy="32" r="10" fill="white" fillOpacity="0.3" stroke="white" strokeWidth="2"/>
        <circle cx="32" cy="32" r="4" fill="white"/>
      </svg>
    ),
    loadbalancer: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#0078D4"/>
        <rect x="26" y="16" width="12" height="10" rx="2" fill="white"/>
        <rect x="14" y="38" width="10" height="10" rx="2" fill="white"/>
        <rect x="27" y="38" width="10" height="10" rx="2" fill="white"/>
        <rect x="40" y="38" width="10" height="10" rx="2" fill="white"/>
        <path d="M32 26v6M32 32l-13 6M32 32v6M32 32l13 6" stroke="white" strokeWidth="1.5"/>
      </svg>
    ),
    vm: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#0078D4"/>
        <rect x="16" y="20" width="32" height="24" rx="2" fill="white" fillOpacity="0.2" stroke="white" strokeWidth="2"/>
        <rect x="22" y="26" width="20" height="12" fill="white"/>
        <rect x="28" y="44" width="8" height="4" fill="white"/>
      </svg>
    ),
    aks: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#0078D4"/>
        <circle cx="32" cy="32" r="14" fill="white" fillOpacity="0.2" stroke="white" strokeWidth="2"/>
        <circle cx="32" cy="32" r="5" fill="white"/>
        <circle cx="32" cy="20" r="3" fill="white"/>
        <circle cx="43" cy="38" r="3" fill="white"/>
        <circle cx="21" cy="38" r="3" fill="white"/>
        <path d="M32 27v-4M36 34l4 2M28 34l-4 2" stroke="white" strokeWidth="1.5"/>
      </svg>
    ),
    sqldb: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#0078D4"/>
        <ellipse cx="32" cy="22" rx="14" ry="6" fill="white"/>
        <path d="M18 22v20c0 3.3 6.3 6 14 6s14-2.7 14-6V22" stroke="white" strokeWidth="2"/>
        <path d="M18 32c0 3.3 6.3 6 14 6s14-2.7 14-6" stroke="white" strokeWidth="1.5"/>
      </svg>
    ),
    cosmosdb: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#0078D4"/>
        <circle cx="32" cy="32" r="14" fill="white" fillOpacity="0.2" stroke="white" strokeWidth="2"/>
        <ellipse cx="32" cy="32" rx="10" ry="4" fill="none" stroke="white" strokeWidth="1.5"/>
        <ellipse cx="32" cy="32" rx="4" ry="10" fill="none" stroke="white" strokeWidth="1.5" transform="rotate(60 32 32)"/>
        <ellipse cx="32" cy="32" rx="4" ry="10" fill="none" stroke="white" strokeWidth="1.5" transform="rotate(-60 32 32)"/>
        <circle cx="32" cy="32" r="3" fill="white"/>
      </svg>
    ),
    storage: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#0078D4"/>
        <rect x="18" y="18" width="28" height="8" rx="1" fill="white"/>
        <rect x="18" y="28" width="28" height="8" rx="1" fill="white" fillOpacity="0.7"/>
        <rect x="18" y="38" width="28" height="8" rx="1" fill="white" fillOpacity="0.4"/>
      </svg>
    ),
    keyvault: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#0078D4"/>
        <rect x="22" y="28" width="20" height="18" rx="2" fill="white"/>
        <circle cx="32" cy="22" r="6" fill="none" stroke="white" strokeWidth="2"/>
        <circle cx="32" cy="37" r="3" fill="#0078D4"/>
      </svg>
    ),
  },
  
  // GCP Icons
  gcp: {
    cloudcdn: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#4285F4"/>
        <circle cx="32" cy="32" r="12" fill="white" fillOpacity="0.3" stroke="white" strokeWidth="2"/>
        <path d="M32 20v4M32 40v4M20 32h4M40 32h4" stroke="white" strokeWidth="2"/>
        <circle cx="32" cy="32" r="5" fill="white"/>
      </svg>
    ),
    loadbalancing: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#4285F4"/>
        <circle cx="32" cy="20" r="6" fill="white"/>
        <rect x="16" y="38" width="8" height="10" rx="1" fill="white"/>
        <rect x="28" y="38" width="8" height="10" rx="1" fill="white"/>
        <rect x="40" y="38" width="8" height="10" rx="1" fill="white"/>
        <path d="M32 26v6M32 32L20 38M32 32v6M32 32l12 6" stroke="white" strokeWidth="1.5"/>
      </svg>
    ),
    computeengine: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#4285F4"/>
        <rect x="18" y="18" width="28" height="28" rx="2" fill="white" fillOpacity="0.2" stroke="white" strokeWidth="2"/>
        <path d="M26 26h12v12H26z" fill="white"/>
        <path d="M30 30h4v4h-4z" fill="#4285F4"/>
      </svg>
    ),
    gke: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#4285F4"/>
        <path d="M32 18l12 7v14l-12 7-12-7V25l12-7z" fill="white" fillOpacity="0.3" stroke="white" strokeWidth="2"/>
        <circle cx="32" cy="32" r="6" fill="white"/>
      </svg>
    ),
    cloudsql: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#4285F4"/>
        <ellipse cx="32" cy="24" rx="12" ry="6" fill="white"/>
        <path d="M20 24v16c0 3.3 5.4 6 12 6s12-2.7 12-6V24" stroke="white" strokeWidth="2"/>
        <path d="M20 32c0 3.3 5.4 6 12 6s12-2.7 12-6" stroke="white" strokeWidth="1.5" strokeOpacity="0.5"/>
      </svg>
    ),
    cloudstorage: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#4285F4"/>
        <path d="M18 36l14-16 14 16H18z" fill="white"/>
        <rect x="22" y="36" width="20" height="10" fill="white" fillOpacity="0.7"/>
      </svg>
    ),
    cloudrun: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#4285F4"/>
        <path d="M24 20h16v24l-8-6-8 6V20z" fill="white" fillOpacity="0.3" stroke="white" strokeWidth="2"/>
        <path d="M28 28l4 4 4-4" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
    pubsub: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#4285F4"/>
        <circle cx="32" cy="32" r="6" fill="white"/>
        <circle cx="20" cy="24" r="4" fill="white" fillOpacity="0.7"/>
        <circle cx="44" cy="24" r="4" fill="white" fillOpacity="0.7"/>
        <circle cx="20" cy="40" r="4" fill="white" fillOpacity="0.7"/>
        <circle cx="44" cy="40" r="4" fill="white" fillOpacity="0.7"/>
        <path d="M26 30l-4-4M38 30l4-4M26 34l-4 4M38 34l4 4" stroke="white" strokeWidth="1.5"/>
      </svg>
    ),
  },
  
  // Generic Icons
  generic: {
    users: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#6B7280"/>
        <circle cx="32" cy="24" r="8" fill="white"/>
        <path d="M18 48c0-7.7 6.3-14 14-14s14 6.3 14 14" stroke="white" strokeWidth="3" strokeLinecap="round"/>
      </svg>
    ),
    internet: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#6B7280"/>
        <circle cx="32" cy="32" r="14" fill="none" stroke="white" strokeWidth="2"/>
        <ellipse cx="32" cy="32" rx="6" ry="14" fill="none" stroke="white" strokeWidth="1.5"/>
        <path d="M18 32h28M32 18v28" stroke="white" strokeWidth="1.5"/>
      </svg>
    ),
    database: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#6B7280"/>
        <ellipse cx="32" cy="22" rx="14" ry="6" fill="white"/>
        <path d="M18 22v20c0 3.3 6.3 6 14 6s14-2.7 14-6V22" stroke="white" strokeWidth="2"/>
      </svg>
    ),
    server: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#6B7280"/>
        <rect x="18" y="16" width="28" height="12" rx="2" fill="white"/>
        <rect x="18" y="32" width="28" height="12" rx="2" fill="white" fillOpacity="0.7"/>
        <circle cx="24" cy="22" r="2" fill="#6B7280"/>
        <circle cx="24" cy="38" r="2" fill="#6B7280"/>
      </svg>
    ),
    cache: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#6B7280"/>
        <rect x="18" y="24" width="28" height="16" rx="2" fill="white"/>
        <path d="M24 32h4M32 32h4M40 32h2" stroke="#6B7280" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
    security: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#6B7280"/>
        <path d="M32 14L16 22v14c0 8 6.4 15.4 16 18 9.6-2.6 16-10 16-18V22L32 14z" fill="white" fillOpacity="0.3" stroke="white" strokeWidth="2"/>
      </svg>
    ),
    monitoring: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#6B7280"/>
        <rect x="16" y="20" width="32" height="24" rx="2" fill="white" fillOpacity="0.2" stroke="white" strokeWidth="2"/>
        <path d="M22 36l6-8 6 4 8-10" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    queue: (
      <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="64" height="64" rx="8" fill="#6B7280"/>
        <rect x="16" y="26" width="32" height="12" rx="2" fill="white"/>
        <path d="M20 32h6M30 32h6M40 32h6" stroke="#6B7280" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
  }
};

// Get icon by service name
export const getCloudIcon = (serviceName, cloud = "aws") => {
  const normalizedName = serviceName.toLowerCase().replace(/[\s-_]/g, '');
  
  // Try cloud-specific icons first
  const cloudIcons = CloudIcons[cloud] || CloudIcons.aws;
  
  // Service name mapping
  const serviceMap = {
    // AWS mappings
    'route53': 'route53',
    'dns': 'route53',
    'cloudfront': 'cloudfront',
    'cdn': 'cloudfront',
    'elb': 'elb',
    'alb': 'elb',
    'loadbalancer': 'elb',
    'applicationloadbalancer': 'elb',
    'vpc': 'vpc',
    'waf': 'waf',
    'firewall': 'waf',
    'ec2': 'ec2',
    'ecs': 'ecs',
    'fargate': 'fargate',
    'lambda': 'lambda',
    'rds': 'rds',
    'aurora': 'aurora',
    'dynamodb': 'dynamodb',
    'elasticache': 'elasticache',
    'redis': 'elasticache',
    's3': 's3',
    'storage': 's3',
    'iam': 'iam',
    'kms': 'kms',
    'secretsmanager': 'secretsmanager',
    'cloudwatch': 'cloudwatch',
    'monitoring': 'cloudwatch',
    'codecommit': 'codecommit',
    'github': 'codecommit',
    'codepipeline': 'codepipeline',
    'pipeline': 'codepipeline',
    'codebuild': 'codebuild',
    'build': 'codebuild',
    'codedeploy': 'codedeploy',
    'deploy': 'codedeploy',
    'ecr': 'ecr',
    'containerregistry': 'ecr',
    'apigateway': 'apigateway',
    'api': 'apigateway',
    'sns': 'sns',
    'notification': 'sns',
    'sqs': 'sqs',
    'queue': 'sqs',
    // Generic
    'users': 'users',
    'endusers': 'users',
    'internet': 'internet',
    'database': 'database',
    'db': 'database',
    'server': 'server',
    'cache': 'cache',
    'security': 'security',
  };
  
  const mappedName = serviceMap[normalizedName];
  
  if (mappedName && cloudIcons[mappedName]) {
    return cloudIcons[mappedName];
  }
  
  // Try generic icons
  if (CloudIcons.generic[mappedName]) {
    return CloudIcons.generic[mappedName];
  }
  
  // Default to server icon
  return CloudIcons.generic.server;
};
